import { useMemo, useState } from 'react'
import { ChatUser } from '../types'
import { ChannelFilters } from 'stream-chat'

export const useChatFilters = (user: ChatUser) => {
  const [searchText, setSearchText] = useState('')

  const filters: ChannelFilters = useMemo(() => {
    const baseFilter = {
      members: { $in: [user?.id] },
      $or: [
        { type: { $ne: 'messaging' } },
        { 
          type: 'messaging',
          last_message_at: { $exists: true }
        }
      ]
    }

    const search = searchText?.trim?.()

    if (search) {
      return {
        $and: [
          baseFilter,
          {
            $or: [
              {
                type: 'messaging',
                [`search_${user?.id}`]: { $autocomplete: search }
              },
              {
                type: 'team',
                name: { $autocomplete: search }
              },
            ]
          }
        ]
      }
    }

    return baseFilter
  }, [searchText, user?.id])

  return {
    filters,
    searchText,
    setSearchText,
  }
}